import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NotFound = () => {
  return (
    <Container>
      <Content>
        <Title>404</Title>
        <Message>Página no encontrada</Message>
        <Description>
          Lo sentimos, la página que buscas no existe.
        </Description>
        <HomeLink to="/">Volver al inicio</HomeLink>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
`;

const Content = styled.div`
  text-align: center;
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
`;

const Title = styled.h1`
  font-size: 6rem;
  color: var(--primary-color);
  margin: 0;
  line-height: 1;
`;

const Message = styled.h2`
  color: var(--dark-color);
  margin: 1rem 0;
`;

const Description = styled.p`
  color: var(--secondary-color);
  margin-bottom: 2rem;
`;

const HomeLink = styled(Link)`
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  text-decoration: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
    text-decoration: none;
  }
`;

export default NotFound; 